module.exports = __webpack_public_path__ + "img/landing3.ac8b9ea1.png";